module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"on":"on","chapters":"chapters","like":"Like","listen":"Listen","stop":"Stop","error":"Error","comment":"Comment","comments":"No comments | One comment | {count} comment"},"fr":{"on":"Le","chapters":"chapitres","like":"Favoris","listen":"Écouter","stop":"Arrêter","error":"Erreur","comment":"Commenter","comments":"Aucun commentaire | Un commentaire | {count} commentaires"}}')
  delete Component.options._Ctor
}
